import { zUid } from "src/types/zUid";
import { z } from "zod";

export const zCopyByValueRule = z.object({
  parentAttributeId: zUid.nullish(),
  linkAttributeId: zUid.nullish(),
  withRestrictions: z.boolean().nullish(),
  groupIdsToCopy: zUid.array().nullable().optional(),
});

export type ZCopyByValueRule = z.infer<typeof zCopyByValueRule>;
